const variantClasses = {
  green: 'bg-green-900/50 text-green-200 border border-green-700',
  blue: 'bg-blue-900/50 text-blue-200 border border-blue-700',
  amber: 'bg-amber-900/50 text-amber-200 border border-amber-700',
  red: 'bg-red-900/50 text-red-200 border border-red-700',
  purple: 'bg-purple-900/50 text-purple-200 border border-purple-700',
};

export default function Badge({ variant = 'blue', children }) {
  const classes = variantClasses[variant] || variantClasses.blue;

  return (
    <span className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${classes}`}>
      {children}
    </span>
  );
}
